import { render, staticRenderFns } from "./FormulaBox.vue?vue&type=template&id=02df857a&lang=pug"
import script from "./FormulaBox.vue?vue&type=script&lang=js"
export * from "./FormulaBox.vue?vue&type=script&lang=js"
import style0 from "./FormulaBox.vue?vue&type=style&index=0&id=02df857a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports